import { z } from 'zod';

/////////////////////////////////////////
// CORE DOCUMENTS TO CORE DOCUMENTS TEMPLATES SCHEMA
/////////////////////////////////////////

export const CoreDocumentsToCoreDocumentsTemplatesSchema = z.object({
  id: z.number().int(),
  documentId: z.number().int(),
  documentTemplateId: z.number().int(),
})

export type CoreDocumentsToCoreDocumentsTemplates = z.infer<typeof CoreDocumentsToCoreDocumentsTemplatesSchema>

export default CoreDocumentsToCoreDocumentsTemplatesSchema;
